import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Tabs, Tab, Button, Offcanvas } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import {ReactComponent as InfoSvg} from './../../assets/icons/svg/info.svg';
import ListPickup from "../../components/ListPickup";
import { toast } from 'react-toastify';

export default function TrashList() {
  const navigate = useNavigate();
  const loc = useLocation();
  const [pickup, setPickup] = useState([]);
  const [showResp, setShowResp] = useState(false);
  const [tabsActive, setTabsActive] = useState('01');
  const handleCloseResp = () => setShowResp(false);
  const handleShowResp = () => setShowResp(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   if(loc.pathname.includes('cancel')){
      getList('34');
      setTabsActive('34');
   } else if(loc.pathname.includes('done')){
      getList('2');
      setTabsActive('2');
   } else {
      getList('01');
      setTabsActive('01');
   }
  },[])

  const getList = (std) => {
   setLoading(true)
   setPickup([])
   switch (std) {
      case '01':
         transaction.actions.get_pickup(0).then((res)=>{
            let process = [];
            process = res?.data?.data;
            transaction.actions.get_pickup(1).then((ress)=>{
               ress?.data.data.forEach(item => {
                  process.push(item)
               })
               setPickup(process);
            })
            setLoading(false)
         })
         break;
      case '2':
         transaction.actions.get_pickup(2).then((res)=>{
            setPickup(res?.data?.data)
            setLoading(false)
          });
         break;
      case '34':
         transaction.actions.get_pickup(3).then((res)=>{
            let dec = [];
            dec = res?.data?.data;
            transaction.actions.get_pickup(4).then((ress)=>{
               ress?.data.data.forEach(item => {
                  dec.push(item)
               })
               setPickup(dec);
            })
            setLoading(false)
         })
         break;
      default:
         break;
   }
  }

  const updateStatus = (idx,st) => {
   const formData = new FormData();
   formData.append("pickup_request_id", idx+':'+st);
   formData.append("status", st);
   formData.append("date", new Date().getDate());
   formData.append("time", (Number(new Date().getHours()) < 10 ? '0' + new Date().getHours() : new Date().getHours()) + ':' + new Date().getMinutes());
   transaction.actions.post_pickup_status(formData).then((res)=>{
      toast.success(res.data);
      if(st > 2){
         getList('34');
         setTabsActive('34');
      } else if(st === 2){
         getList('2');
         setTabsActive('2');   
      } else {
         getList('01');
         setTabsActive('01');
      }
   }).catch(err => {
      toast.success(err.data);
   })
  } 

  return (
   <div>
      <div className="fixed-top bg-white header">
         <div className="text-center fw-semibold">
               Permintaan Jemput
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>
      <Tabs
         activeKey={tabsActive}
         className="mt-5 pt-5"
         onSelect={(e) => {getList(e), setTabsActive(e)}}
      >
         <Tab eventKey='01' title="Dalam Proses">
            <ListPickup data={pickup} updateStatus={updateStatus} status={0} loading={loading}/>
         </Tab>
         <Tab eventKey='2' title="Selesai">
            <ListPickup data={pickup} updateStatus={updateStatus} status={2} loading={loading}/>
         </Tab>
         <Tab eventKey='34' title="Dibatalkan">
            <ListPickup data={pickup} updateStatus={updateStatus} status={3} loading={loading}/>
         </Tab>
      </Tabs>
      <div className="btn-fixed-btm">
         <div className="d-grid gap-2">
            <Button className="btn-auth rounded-pill py-3 px-5" variant="success" onClick={() => handleShowResp()} >
               BUAT PERMINTAAN JEMPUT
            </Button>
         </div>
      </div>


      <Offcanvas show={showResp} onHide={handleCloseResp} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-5">
            <div className="mb-4 text-center">
               <InfoSvg/>
            </div>
            <div className="text-center fw-bold my-3">PERHATIAN</div>
            <div className="mb-5">
               <div className="text-center text-body ts-ssm">
               <ol>
                  <li>
                     Sampah yang akan dijemput sudah dalam keadaan bersih dan dikemas dengan baik. 
                  </li>
                  <li>
                     Khusus botol plastik, pastikan sudah tidak ada cairan didalamnya
                  </li>
                  <li>
                     Perkiraan biaya penjemputan Rp. 10.000 - Rp. 20.000 (menyesuaikan dengan kebijakan mitra)
                  </li>
               </ol>
               </div>
            </div>

            <div className="d-grid gap-2 mt-4">
               <Button className="btn-auth rounded-pill p-3" variant="success" onClick={() => navigate('/trash/add')} >
                  OK, MENGERTI!
               </Button>
            </div>
         </Offcanvas.Body>
      </Offcanvas>
   </div>
  );
}